export const handleKeyDown = (e, cb, key) => e.key === key ? cb(e) : null;
